import { unidadeOrcamentaria } from "@/types/ug/uo/unidade-orcamentaria";
import { Service } from "../../mainService"
import { PortalError } from "@/types/portal-error";


const unidadeOrcamentariaService = {
    listarUnidadesOrcamentarias,
    editarResponsavel
};

async function listarUnidadesOrcamentarias(todos: boolean): Promise<unidadeOrcamentaria[]> {

    const response = await Service.$http.get(
        process.env.VUE_APP_ENTREGAS_API + `/UnidadeOrcamentaria/uosbyug/${todos}`,
    );
    if (response && response.status === 200) {
        return response.data.map((item: any) => new unidadeOrcamentaria(item))
    }

    throw new PortalError("Erro ao simular assinatura.")



}


async function editarResponsavel(id: number, cpf: string, nome: string, fone: string, email: string) {
    const data = new FormData()
    data.append("Cpf", cpf)
    data.append("Nome", nome)
    data.append("Fone", fone)
    data.append("Email", email)
    const response = await Service.$http.post(
        process.env.VUE_APP_ENTREGAS_API + `/UnidadeOrcamentaria/contatouo/${id}`, data
    );
    if (response && response.status === 200) {
        return response
    }

    throw new PortalError("Erro ao editar dados do responsável.")



}


export default unidadeOrcamentariaService;